import React, { useState } from "react";
import CustomModalLayoutV2 from "../../bidder/Tabs/auctionFloor/components/CustomModalLayoutV2";
import PDFViewer from "../bidder/PDFViewer";
import { Button } from "../../../shadcn/components/ui/button";
interface BidderKYCCustomDocViewerProps {
  isOpen: boolean;
  onClose: () => void;
  documentUrls: string[];
  headingText?: string;
}
export default function BidderKYCCustomDocViewer({
  isOpen,
  onClose,
  documentUrls,
  headingText = "KYC Documents",
}: BidderKYCCustomDocViewerProps) {
  console.log("documentUrls", documentUrls);
  const [currentDocumentIndex, setCurrentDocumentIndex] = useState(0);
  const [failedImageUrls, setFailedImageUrls] = useState<Set<string>>(
    new Set(),
  );

  const currentUrl = documentUrls[currentDocumentIndex];
  const hasImageLoadError = currentUrl
    ? failedImageUrls.has(currentUrl)
    : false;

  const handleImageError = (url: string) => {
    setFailedImageUrls((prev) => new Set(prev).add(url));
  };

  const handleClose = () => {
    setFailedImageUrls(new Set());
    onClose();
  };
  const onPrevious = () => {
    setCurrentDocumentIndex((prev) =>
      prev > 0 ? prev - 1 : documentUrls.length - 1,
    );
  };
  const onNext = () => {
    setCurrentDocumentIndex((prev) =>
      prev < documentUrls.length - 1 ? prev + 1 : 0,
    );
  };

  return (
    <CustomModalLayoutV2
      open={isOpen}
      onClose={handleClose}
      blurBackground={true}
      className="!w-full mx-2 sm:mx-4 md:mx-6 max-w-[580px] max-h-[95vh] sm:max-h-[90vh] overflow-hidden"
      childrenClassName="py-4 px-0 overflow-hidden flex flex-col"
    >
      <div className="flex flex-col h-full max-h-[95vh] sm:max-h-[90vh]">
        {/* Header */}
        <div className="flex items-center justify-between px-4 sm:px-6 pt-4 sm:pt-6 pb-3 sm:pb-4 border-b flex-shrink-0 bg-white">
          <h3 className="text-lg sm:text-xl font-semibold text-brand-textBlack">
            {headingText}
          </h3>
          {documentUrls.length > 1 && (
            <div className="text-xs sm:text-sm font-medium text-gray-600 bg-gray-100 px-2 sm:px-3 py-1 sm:py-1.5 rounded-full">
              {currentDocumentIndex + 1} / {documentUrls.length}
            </div>
          )}
        </div>

        {/* Document Content Area */}
        <div className="flex-1 overflow-auto relative min-h-0 bg-gray-50">
          {documentUrls.length > 0 && currentUrl ? (
            !hasImageLoadError ? (
              <div className="flex items-start justify-center w-full min-h-full p-2 sm:p-4">
                {/* eslint-disable-next-line @next/next/no-img-element */}
                <img
                  src={currentUrl}
                  alt={`KYC Document ${currentDocumentIndex + 1}`}
                  className="max-w-full w-auto h-auto object-contain rounded-lg shadow-sm"
                  onError={() => handleImageError(currentUrl)}
                />
              </div>
            ) : (
              <div className="flex items-center justify-center w-full h-full p-2 sm:p-4">
                <div className="w-full h-full rounded-lg shadow-sm overflow-hidden bg-white">
                  <PDFViewer pdf_url={currentUrl} />
                </div>
              </div>
            )
          ) : (
            <div className="flex items-center justify-center h-full text-gray-500">
              <p>No document available</p>
            </div>
          )}
        </div>

        {/* Navigation Buttons */}
        {documentUrls.length > 1 && (
          <div className="flex items-center justify-between px-4 sm:px-6 py-3 sm:py-4 border-t bg-white flex-shrink-0 gap-2 sm:gap-0">
            <Button
              onClick={onPrevious}
              disabled={documentUrls.length === 0}
              className="flex-1 sm:flex-initial text-xs sm:text-sm"
            >
              Previous
            </Button>
            <Button
              onClick={onNext}
              disabled={documentUrls.length === 0}
              className="flex-1 sm:flex-initial text-xs sm:text-sm"
            >
              Next
            </Button>
          </div>
        )}
      </div>
    </CustomModalLayoutV2>
  );
}
